export const DEFAULT_FORMAT = "yyyy-MM-dd'T'HH:mm:ss'Z'";

export const toUtcIso = luxonDateTime => {
  if (luxonDateTime?.isValid) {
    // There are no guarantees that the incoming date/time is UTC.  So, we must
    // explicitly set to UTC since the DEFAULT_FORMAT expresses the time as such.
    return luxonDateTime.toUTC().toFormat(DEFAULT_FORMAT);
  }
};
